import SalesAdjustmentFormContainer from './sales-adjustment-form-container';

export default SalesAdjustmentFormContainer;
